// SMART-TOOLS-BROWSER CONTROLLER — the cross-tree opener for the ONE Smart
// Tools Browser (owner directive 2026-07-23: "a full smart tools browser with
// categorization, tagging etc, because 220 tools is far too much to add to the
// left hand drawer").
//
// Same module-level pub/sub shape as paintModalController: a registered state
// setter so ANY entry point (the Smart drawer's "Browse all" button today, a
// ribbon button tomorrow) opens the singleton without prop-drilling or a shared
// React context. This module holds NO React and imports nothing — the host
// (SmartToolsBrowserHost, in SmartToolsBrowser.jsx) registers its setState on
// mount; openSmartToolsBrowser pushes a config to it.
//
// ONE browser at a time: opening again REPLACES the open one. The bumped _id is
// the modal's React key so a re-open remounts fresh.
let _setConfig = null;
let _seq = 0;

/** The singleton host registers its setState here on mount; returns an
 *  unregister fn for unmount. */
export function registerSmartToolsBrowserHost(setter) {
  _setConfig = setter;
  return () => { if (_setConfig === setter) _setConfig = null; };
}

/**
 * Open the Smart Tools Browser.
 * @param {object} [config]
 *   editor        — the editor facade; the browser's fallback insert path calls
 *                   editor.addSmartObject(id) when SM-A's tool modal is absent.
 *   initialDomain — a domain id / FEATURED_DOMAIN / ALL_DOMAIN to preselect in
 *                   the rail (default: Featured).
 */
export function openSmartToolsBrowser(config = {}) {
  if (typeof _setConfig !== 'function') {
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn('[smartToolsBrowser] openSmartToolsBrowser called with no SmartToolsBrowserHost mounted');
    }
    return;
  }
  _setConfig({ ...config, _id: ++_seq });
}

/** Close the browser if open. */
export function closeSmartToolsBrowser() {
  if (typeof _setConfig === 'function') _setConfig(null);
}
